import api from "../../index";
import { configurationVariables } from "../../../environment/index";

const idOrigem = 3;
const idHotsite = parseInt(configurationVariables.IdHotsite);


export const checkCryptoAccount = async (idCliente) => {
  try {
    const { data: response, status } = await api.get(
      `/CarrinhoCripto/CheckCryptoAccount?idCliente=${idCliente}`
    );

    const hasAccount = response.data === true;
    
    return {
      status,
      errorMessage: response.errorMessage,
      data: response.data,
      hasAccount: hasAccount,
      success: response.data === true, 
      isActive: hasAccount, 
      requiresVerification: false 
    };
  } catch (error) {
    console.error("Erro ao verificar conta cripto:", error);
    return {
      success: false,
      errorMessage: error.message || "Erro ao verificar conta de cripto",
      hasAccount: false,
      data: null
    };
  }
};


export const createCryptoSubaccount = async (idCliente) => {
  try {
    const { data: response, status } = await api.post(
      `/CarrinhoCripto/CreateSubaccount?idCliente=${idCliente}`
    );

    return {
      status,
      errorMessage: response.errorMessage,
      data: response.data,
      success: response.success === true,
      message: response.message || response.message_cod || response.errorMessage,
      message_cod: response.message_cod
    };
  } catch (error) {
    console.error("Erro ao criar subconta cripto:", error);
    return {
      success: false,
      errorMessage: error.message || "Erro ao criar conta de cripto"
    };
  }
};

export const getQuote = async (idCliente, quoteRequest) => {
  try {
    const { data: response, status } = await api.post(
      `/CarrinhoCripto/GerarQuote?idCliente=${idCliente}`,
      quoteRequest
    );

    return {
      status,
      errorMessage: response.errorMessage,
      data: response.data,
    };
  } catch (error) {
    throw new Error(error + "RXMFI");
  }
};


export const executeQuote = async (idCliente, transactionRequest) => {
  try {
    // Adiciona os valores fixos ao request
    const executeRequest = {
      ...transactionRequest,
      idOrigem: idOrigem,
      idHotsite: idHotsite,
    };

    const { data: response, status } = await api.post(
      `/CarrinhoCripto/ExecutarTransacao?idCliente=${idCliente}`,
      executeRequest
    );

    return {
      status,
      data: response, 
      rawData: response.data, 
      errorMessage: response.errorMessage,
      success: response.data === true && !response.errorMessage,
      message: response.errorMessage ? response.errorMessage : "Transação executada com sucesso",
      messageCod: null, 
      orderId: null, 
      amount: null,
      execAmount: null,
      price: null,
      market: null,
      type: null,
    };
  } catch (error) {
    console.error("executeQuote - Erro:", error);

    return {
      success: false,
      errorMessage: error.message || "Erro ao executar transação",
      message: error.message || "Erro ao executar transação",
      messageCod: "NETWORK_ERROR",
      status: error.response?.status || 500,
      data: null,
      rawData: null,
    };
  }
};



export const createExecuteTransactionRequest = (
  quoteId,
  taxaAplicada,
  externalId,
  idMoedaCredito,
  idMoedaDebito,
  isVenda
) => {
  return {
    QuoteId: quoteId,
    TaxaAplicada: taxaAplicada,
    ExternalId: externalId,
    IDMoedaCredito: idMoedaCredito,
    IDMoedaDebito: idMoedaDebito,
    isVenda: isVenda
  };
};

export const getBalance = async (idCliente) => {
  try {
    // Use desestruturação consistente
    const { data: apiResponse, status } = await api.get(
      `/CarrinhoCripto/GetBalance?idCliente=${idCliente}`
    );

    // Status 204 - Sem conteúdo
    if (status === 204) {
      return {
        status: 204,
        errorMessage: null,
        data: { 
          success: true, 
          BRL: 0, 
          USDT: 0, 
          USDC: 0,
          BRL_locked: 0,
          USDT_locked: 0,
          USDC_locked: 0,
          timestamp: new Date().toISOString()
        },
        success: true,
      };
    }
    
    // Verifica se a resposta tem a estrutura esperada
    if (!apiResponse || typeof apiResponse !== 'object') {
      console.error("Resposta da API inválida:", apiResponse);
      return {
        status,
        success: false,
        errorMessage: "Resposta da API em formato inválido",
        data: null
      };
    }
    
    // EXTRAÇÃO CORRIGIDA: 
    // apiResponse já é o objeto completo que você recebeu no navegador
    // A propriedade 'data' dentro de apiResponse contém os dados do saldo
    const balanceData = apiResponse.data || {};
    const errorMessage = apiResponse.errorMessage || null;
    
    return {
      status,
      errorMessage: errorMessage,
      data: balanceData, // Aqui está {success: true, USDT: 2604.4, etc}
      success: balanceData.success === true,
    };
    
  } catch (error) {
    console.error("Erro ao buscar saldo:", error);
    
    // Debug detalhado do erro
    if (error.response) {
      // O servidor respondeu com um status de erro
      console.error("Status do erro:", error.response.status);
      console.error("Dados do erro:", error.response.data);
      console.error("Headers do erro:", error.response.headers);
      
      return {
        success: false,
        errorMessage: error.response.data?.errorMessage || `Erro ${error.response.status}`,
        data: error.response.data || null,
        status: error.response.status
      };
    } else if (error.request) {
      // A requisição foi feita mas não houve resposta
      console.error("Sem resposta do servidor:", error.request);
      return {
        success: false,
        errorMessage: "Sem resposta do servidor. Verifique sua conexão.",
        data: null,
        status: 0
      };
    } else {
      // Algo aconteceu na configuração da requisição
      console.error("Erro na configuração:", error.message);
      return {
        success: false,
        errorMessage: error.message || "Erro ao configurar requisição",
        data: null,
        status: 0
      };
    }
  }
};

// DEPRECIADO: Esta função foi substituída por listarTransacoes
// Mantida para referência histórica
/*
export const getSubaccTransactions = async (idCliente) => {
  try {
    console.log("Buscando transações de cripto para cliente:", idCliente);
    
    const { data: response, status } = await api.get(
      `/CarrinhoCripto/GetSubaccTransactions?idCliente=${idCliente}`
    );

    console.log("Resposta da API getSubaccTransactions:", response);
    
    return {
      status,
      errorMessage: response.errorMessage,
      data: response.data,
      success: response.data?.success || false,
    };
  } catch (error) {
    console.error("Erro ao buscar transações de cripto:", error);
    return {
      success: false,
      errorMessage: error.message || "Erro ao buscar transações de cripto",
      data: null
    };
  }
};
*/

export const listarTransacoes = async (idCliente, idOrigem = 3) => {
  try {
    const { data: response, status } = await api.get(
      `/CarrinhoCripto/ListarTransacoes?idCliente=${idCliente}&idOrigem=${idOrigem}`
    );

    return {
      status,
      errorMessage: response.errorMessage,
      data: response.data || [],
      success: Array.isArray(response.data) && response.data.length >= 0,
    };
  } catch (error) {
    console.error("Erro ao buscar transações de cripto:", error);
    return {
      success: false,
      errorMessage: error.message || "Erro ao buscar transações de cripto",
      data: null
    };
  }
};

// Adicione esta função no arquivo de API
export const getMoedasDisponiveis = async () => {
  try {
    const { data: response, status } = await api.get(
      `/CarrinhoCripto/GetMoedasDisponiveis`
    );

    return {
      status,
      errorMessage: response.errorMessage,
      data: response.data,
      success: response.data && Array.isArray(response.data),
    };
  } catch (error) {
    console.error("Erro ao buscar moedas disponíveis:", error);
    return {
      success: false,
      errorMessage: error.message || "Erro ao buscar moedas disponíveis",
      data: null
    };
  }
};

// Alias para compatibilidade (aponta para a nova função)
export const getSubaccTransactions = listarTransacoes;

const CriptoAPI = {
  checkCryptoAccount,
  createCryptoSubaccount,
  getQuote,
  executeQuote,
  createExecuteTransactionRequest,
  getBalance,
  listarTransacoes,
  getSubaccTransactions,
  getMoedasDisponiveis
};

export default CriptoAPI;